(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.popOver = {
    attach: function (context) {

      //Based on Bootstrap 4 popover
      $('[data-toggle="popover"]').popover({
        template: '<div class="popover" role="tooltip">\
        <div class="arrow"></div>\
        <a role="button" tabindex="0" class="popover-close"><span aria-hidden="true" class="icon-times-circle-o"></span><span class="sr-only">Close popover</span></a>\
        <div class="popover-header"></div>\
        <div class="popover-body"></div>\
      </div>',
        placement: 'top',
      });

      $(document).on('click', function (e) {
        if ($(e.target).hasClass('regulation-popover')) {
          $('[data-toggle="popover"]').not($(e.target)).popover('hide');
        }
        else {
          $('[data-toggle="popover"]').popover('hide');
        }
      });

      //Hide popover on close button
      $(document).on("click", ".popover .popover-close", function () {
        $(this).parents(".popover").popover('hide');
      });

      //Hide popover on escape key
      $(document).keyup(function (event) {
        if (event.which === 27) {
          $('[data-toggle="popover"]').popover('hide');
        }
      });


    },
  };
})(jQuery, Drupal);
